<asw-my-booking-itinerary-pres [functionList]="getFunctionList"></asw-my-booking-itinerary-pres>
